/* global YASQE, YASR */
import { context } from '@/lib/ns'

const yasqeEl = document.querySelector('.foko-yasqe')
const yasrEl = document.querySelector('.foko-yasr')

const yasqe = YASQE(yasqeEl, {
  persistent: null,
  sparql: {
    endpoint: '/linked-data/',
    showQueryButton: true
  }
})

yasqe.addPrefixes(context)

const yasr = YASR(yasrEl, {
  getUsedPrefixes: yasqe.getPrefixesFromQuery
})

yasqe.options.sparql.callbacks.complete = yasr.setResponse

yasqe.query()
